// Service for communicating with Laravel backend
import { config } from '../config';

const BACKEND_URL = config.BACKEND_URL;

class BackendService {
  constructor() {
    this.csrfToken = null;
  }

  // Get CSRF token from Laravel
  async getCsrfToken() {
    try {
      const response = await fetch(`${BACKEND_URL}/csrf-token`, {
        method: 'GET',
        credentials: 'include',
      });
      
      if (response.ok) {
        const data = await response.json();
        this.csrfToken = data.csrf_token;
        console.log('CSRF Token obtained:', this.csrfToken);
        return this.csrfToken;
      }
    } catch (error) {
      console.error('Error fetching CSRF token:', error);
    }
    return null;
  }

  // Make authenticated request with CSRF token
  async request(endpoint, options = {}) {
    const url = `${BACKEND_URL}${endpoint}`;
    
    // Ensure we have CSRF token for POST and PUT requests
    if ((options.method === 'POST' || options.method === 'PUT') && !this.csrfToken) {
      await this.getCsrfToken();
    }

    const config = {
      credentials: 'include', // Include cookies for session
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        ...options.headers,
      },
      ...options,
    };

    // Add CSRF token for POST and PUT requests
    if ((options.method === 'POST' || options.method === 'PUT') && this.csrfToken) {
      config.headers['X-CSRF-TOKEN'] = this.csrfToken;
      console.log('Adding CSRF token to request:', this.csrfToken);
    }

    try {
      const response = await fetch(url, config);
      
      if (!response.ok) {
        const errorData = await response.json().catch(() => ({}));
        throw new Error(errorData.message || `HTTP error! status: ${response.status}`);
      }
      
      return await response.json();
    } catch (error) {
      console.error('API request failed:', error);
      throw error;
    }
  }

  // Admin authentication methods
  async adminLogin(email, password) {
    return this.request('/admin/login', {
      method: 'POST',
      body: JSON.stringify({ email, password }),
    });
  }

  async adminLogout() {
    return this.request('/admin/logout', {
      method: 'POST',
    });
  }

  async getAdminProfile() {
    return this.request('/admin/me', {
      method: 'GET',
    });
  }

  // Check if admin is authenticated
  async checkAuthStatus() {
    try {
      const profile = await this.getAdminProfile();
      return { isAuthenticated: true, admin: profile.admin };
    } catch (error) {
      return { isAuthenticated: false, admin: null };
    }
  }

  // Quote submission
  async submitQuote(quoteData) {
    return this.request('/quotes/submit', {
      method: 'POST',
      body: JSON.stringify(quoteData),
    });
  }
}

export const backendService = new BackendService(); 